/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccountDto } from './BankAccountDto';
import {
    BankAccountDtoFromJSON,
    BankAccountDtoFromJSONTyped,
    BankAccountDtoToJSON,
    BankAccountDtoToJSONTyped,
} from './BankAccountDto';
import type { DueDateDto } from './DueDateDto';
import {
    DueDateDtoFromJSON,
    DueDateDtoFromJSONTyped,
    DueDateDtoToJSON,
    DueDateDtoToJSONTyped,
} from './DueDateDto';
import type { MandatePayerOptionDto } from './MandatePayerOptionDto';
import {
    MandatePayerOptionDtoFromJSON,
    MandatePayerOptionDtoFromJSONTyped,
    MandatePayerOptionDtoToJSON,
    MandatePayerOptionDtoToJSONTyped,
} from './MandatePayerOptionDto';
import type { MandatePayer } from './MandatePayer';
import {
    MandatePayerFromJSON,
    MandatePayerFromJSONTyped,
    MandatePayerToJSON,
    MandatePayerToJSONTyped,
} from './MandatePayer';

/**
 * 
 * @export
 * @interface QuoteMandateDto
 */
export interface QuoteMandateDto {
    /**
     * Date de début du mandat — date CALENDAIRE (ISO sans Z, ex "2026-08-01T00:00:00") : afficher/préremplir par découpe de string, jamais de conversion de fuseau
     * 
     * @type {string}
     * @memberof QuoteMandateDto
     */
    startDate: string;
    /**
     * 
     * @type {DueDateDto}
     * @memberof QuoteMandateDto
     */
    dueDate?: DueDateDto;
    /**
     * Identifiant de la fréquence de prélèvement
     * @type {string}
     * @memberof QuoteMandateDto
     */
    frequencyCode: string;
    /**
     * Indique s'il s'agit d'un contrat de groupe
     * @type {boolean}
     * @memberof QuoteMandateDto
     */
    isGroupContract: boolean;
    /**
     * L'assuré doit signer son propre mandat SEPA : le bloc de saisie du compte bancaire est alors proposé. Vrai pour un contrat individuel, et pour un aliment de contrat cadre configuré en « chaque aliment règle son propre prélèvement ». Faux quand le souscripteur du collectif règle pour tous, le mandat étant déjà signé au niveau du contrat cadre.
     * @type {boolean}
     * @memberof QuoteMandateDto
     */
    requiresOwnMandate: boolean;
    /**
     * 
     * @type {MandatePayer}
     * @memberof QuoteMandateDto
     */
    payer: MandatePayer;
    /**
     * Le tunnel autorise le courtier encaisseur : le panneau propose le choix du payeur (souscripteur ou courtier). Faux sinon, le payeur est toujours le souscripteur.
     * @type {boolean}
     * @memberof QuoteMandateDto
     */
    brokerPaymentAllowed: boolean;
    /**
     * Payeurs proposés : toujours le souscripteur ; le bénéficiaire si le dossier en a exactement un ; le courtier si le tunnel autorise l'encaissement courtier.
     * @type {Array<MandatePayerOptionDto>}
     * @memberof QuoteMandateDto
     */
    payerOptions?: Array<MandatePayerOptionDto>;
    /**
     * Compte débité par le mandat courant, quel que soit son propriétaire (souscripteur, bénéficiaire ou cabinet)
     * @type {string}
     * @memberof QuoteMandateDto
     */
    selectedBankAccountId?: string | null;
    /**
     * Comptes bancaires du payeur enregistré du devis, souscripteur ou bénéficiaire (ceux du cabinet viennent de /comptes/courtier-connecte)
     * @type {Array<BankAccountDto>}
     * @memberof QuoteMandateDto
     */
    bankAccounts: Array<BankAccountDto>;
}



/**
 * Check if a given object implements the QuoteMandateDto interface.
 */
export function instanceOfQuoteMandateDto(value: object): value is QuoteMandateDto {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('frequencyCode' in value) || value['frequencyCode'] === undefined) return false;
    if (!('isGroupContract' in value) || value['isGroupContract'] === undefined) return false;
    if (!('requiresOwnMandate' in value) || value['requiresOwnMandate'] === undefined) return false;
    if (!('payer' in value) || value['payer'] === undefined) return false;
    if (!('brokerPaymentAllowed' in value) || value['brokerPaymentAllowed'] === undefined) return false;
    if (!('bankAccounts' in value) || value['bankAccounts'] === undefined) return false;
    return true;
}

export function QuoteMandateDtoFromJSON(json: any): QuoteMandateDto {
    return QuoteMandateDtoFromJSONTyped(json, false);
}

export function QuoteMandateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteMandateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'],
        'dueDate': json['dueDate'] == null ? undefined : DueDateDtoFromJSON(json['dueDate']),
        'frequencyCode': json['frequencyCode'],
        'isGroupContract': json['isGroupContract'],
        'requiresOwnMandate': json['requiresOwnMandate'],
        'payer': MandatePayerFromJSON(json['payer']),
        'brokerPaymentAllowed': json['brokerPaymentAllowed'],
        'payerOptions': json['payerOptions'] == null ? undefined : ((json['payerOptions'] as Array<any>).map(MandatePayerOptionDtoFromJSON)),
        'selectedBankAccountId': json['selectedBankAccountId'] == null ? undefined : json['selectedBankAccountId'],
        'bankAccounts': ((json['bankAccounts'] as Array<any>).map(BankAccountDtoFromJSON)),
    };
}

export function QuoteMandateDtoToJSON(json: any): QuoteMandateDto {
    return QuoteMandateDtoToJSONTyped(json, false);
}

export function QuoteMandateDtoToJSONTyped(value?: QuoteMandateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'dueDate': DueDateDtoToJSON(value['dueDate']),
        'frequencyCode': value['frequencyCode'],
        'isGroupContract': value['isGroupContract'],
        'requiresOwnMandate': value['requiresOwnMandate'],
        'payer': MandatePayerToJSON(value['payer']),
        'brokerPaymentAllowed': value['brokerPaymentAllowed'],
        'payerOptions': value['payerOptions'] == null ? undefined : ((value['payerOptions'] as Array<any>).map(MandatePayerOptionDtoToJSON)),
        'selectedBankAccountId': value['selectedBankAccountId'],
        'bankAccounts': ((value['bankAccounts'] as Array<any>).map(BankAccountDtoToJSON)),
    };
}

